<template>
  <div class="page-wrapper">
    <div class="page-container">
      <PageHeader class="base-page-header base-shadow"> </PageHeader>
      <el-form
        :model="form"
        :rules="rules"
        ref="caseForm"
        label-width="120px"
        label-position="top"
        class="company-ruleForm"
        status-icon
        v-loading="loading"
        :disabled="submitting"
      >
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="24">
            <el-form-item label="封面图" prop="cover_image_url">
              <SingleImgUpload
                v-model="form.cover_image_url"
                class="cover-image"
              /> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item label="名称" prop="name_cn" class="base-form-item">
              <el-input
                v-model.trim="form.name_cn"
                clearable
                placeholder="请输入"
              ></el-input></el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item
              label="名称（英文）"
              prop="name_en"
              class="base-form-item"
            >
              <el-input
                v-model.trim="form.name_en"
                clearable
                placeholder="请输入"
              ></el-input></el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="24">
            <el-form-item
              label="案例类型"
              prop="type_ids"
              class="base-form-item"
            >
              <TypeCheckBox v-model="form.type_ids"/></el-form-item
          ></el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="案例介绍（中文）" prop="description_cn">
              <el-input
                type="textarea"
                :rows="4"
                v-model.trim="form.description_cn"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="案例介绍（英文）" prop="description_en">
              <el-input
                type="textarea"
                :rows="4"
                v-model.trim="form.description_en"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="24">
            <el-form-item label="次序" prop="seq" class="base-form-item">
              <el-input
                type="number"
                v-model.trim="form.seq"
                clearable
                placeholder="请输入"
                style="max-width: 250px;"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :sm="24">
            <el-form-item label="效果图合集(显示顺序从左到右)" prop="images">
              <DraggbleSort
                syncSortKey
                v-model="form.images"
                class="medias-list-wrap"
              >
                <template v-slot:default="slotProps">
                  <ProductImgUpload
                    class="medias-item"
                    tips="选择图片"
                    v-model="slotProps.item.url"
                    @remove="removeImages(slotProps.index)"
                  />
                </template>
              </DraggbleSort>
              <div class="add-madias-item">
                <el-button-group>
                  <el-button
                    size="small"
                    icon="el-icon-picture-outline"
                    @click="addImages"
                    >添加图片</el-button
                  >
                </el-button-group>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-divider content-position="center">次要资料</el-divider>
          </el-col>

          <el-col :xs="24" :sm="12" :md="24">
            <el-form-item label="海报图" prop="poster_image_url">
              <SingleImgUpload
                v-model="form.poster_image_url"
                class="cover-image"
              /> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="海报标语（中文）" prop="poster_slogan_cn">
              <el-input
                v-model.trim="form.poster_slogan_cn"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="海报标语（英文）" prop="poster_slogan_en">
              <el-input
                v-model.trim="form.poster_slogan_en"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="国家（中文）" prop="country_cn">
              <el-input
                v-model.trim="form.country_cn"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="国家（英文）" prop="country_en">
              <el-input
                v-model.trim="form.country_en"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="省份（中文）" prop="province_cn">
              <el-input
                v-model.trim="form.province_cn"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="省份（英文）" prop="province_en">
              <el-input
                v-model.trim="form.province_en"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="城市（中文）" prop="city_cn">
              <el-input
                v-model.trim="form.city_cn"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="城市（英文）" prop="city_en">
              <el-input
                v-model.trim="form.city_en"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="区域（中文）" prop="region_cn">
              <el-input
                v-model.trim="form.region_cn"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="区域（英文）" prop="region_en">
              <el-input
                v-model.trim="form.region_en"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="街道（中文）" prop="street_cn">
              <el-input
                v-model.trim="form.street_cn"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
          <el-col :xs="24" :sm="12" :md="8"
            ><el-form-item label="街道（英文）" prop="street_en">
              <el-input
                v-model.trim="form.street_en"
                clearable
                placeholder="请输入"
              ></el-input> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
    </div>
    <div class="control-btn-group">
      <el-button
        v-if="isEmprty(this.currentId)"
        type="primary"
        size="small"
        icon="el-icon-s-promotion"
        :loading="submitting"
        @click="submitForm('caseForm')"
        >{{ submitting ? "保存中..." : "保存" }}</el-button
      >
      <el-button
        type="warning"
        size="small"
        icon="el-icon-s-promotion"
        :loading="submitting"
        @click="editForm('caseForm')"
        v-if="!isEmprty(this.currentId)"
        >{{ submitting ? "保存中..." : "保存修改" }}</el-button
      >
    </div>
  </div>
</template>

<script>
import { GetCaseById, PostCases, PutCases } from "./api";
import { GetCaseTypesList } from "@/views/caseTypes/api";
import { ShowApiError } from "@/request/error";
import { isEmprty } from "@/utils/validate";
import PageHeader from "@/components/PageHeader";
import SingleImgUpload from "@/components/SingleImgUpload";
import TypeCheckBox from "./components/TypeCheckBox";
import ProductImgUpload from "@/components/ProductImgUpload";
import DraggbleSort from "@/components/DraggbleSort";
import _lodash from "lodash";
export default {
  components: {
    PageHeader,
    SingleImgUpload,
    TypeCheckBox,
    DraggbleSort,
    ProductImgUpload,
  },

  data() {
    return {
      loading: false,
      submitting: false,
      currentId: null,
      form: {
        name_cn: "",
        name_en: "",
        country_cn: "",
        country_en: "",
        province_cn: "",
        province_en: "",
        city_cn: "",
        city_en: "",
        region_cn: "",
        region_en: "",
        street_cn: "",
        street_en: "",
        description_cn: "",
        description_en: "",
        product_ids: [],
        type_ids: [],
        images: [
          // {
          //   url: "",
          //   seq: 0,
          // },
        ],
        shooting_date: "",
        poster_image_url: "",
        poster_slogan_cn: "",
        poster_slogan_en: "",
        cover_image_url: "",
        seq: 0,
      },
      rules: {
        title: [{ required: true, message: "请输入用户名称", trigger: "blur" }],

        content: [{ required: true, message: "请输入内容", trigger: "blur" }],
      },
    };
  },
  watch: {
    $route: {
      handler() {
        if (this.$route.name === "CasesForm") {
          if (this.$route.params.id && !isEmprty(this.$route.params.id)) {
            this.currentId = this.$route.params.id;
            this.getFormData();
          } else {
            this.currentId = null;
          }
        }
      },
      immediate: true,
    },
  },

  methods: {
    isEmprty,
    GetCaseTypesList,
    // 实拍图
    addImages() {
      let item = {
        url: "",
        seq: this.form.images.length,
      };
      this.form.images.push(item);
    },
    removeImages(index) {
      this.form.images.splice(index, 1);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitting = true;
          PostCases([this.form])
            .then((res) => {
              this.submitting = false;
              this.$message.success("新增成功");
              this.onEmitSuccess(res.data);
            })
            .catch((err) => {
              this.submitting = false;
              ShowApiError("新增失败", err);
            });
        } else {
          this.$message.warning("表单有误，请检查");
          return false;
        }
      });
    },
    editForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitting = true;
          let params = _lodash.defaultsDeep({}, this.form);
          params.images.forEach((item) => {
            delete item.id;
            return item;
          });
          params.id = Number(this.currentId);
          PutCases([params])
            .then((res) => {
              this.submitting = false;
              this.inintForm();
              this.$message.success("修改成功");
              this.getFormData();
              this.onEmitSuccess(res.data);
            })
            .catch((err) => {
              this.submitting = false;
              ShowApiError("修改失败", err);
            });
        } else {
          this.$message.warning("表单有误，请检查");
          return false;
        }
      });
    },
    getFormData() {
      this.loading = true;
      this.inintForm();
      GetCaseById(this.currentId)
        .then((res) => {
          for (const key in res.data) {
            if (Object.hasOwnProperty.call(this.form, key)) {
              this.form[key] = res.data[key];
            }
          }
          this.form.type_ids = res.data.types.map((item) => item.id);
          console.log(this.form);
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          ShowApiError("获取表单", err);
        });
    },

    onCancel(data = {}) {
      this.$emit("cancel", data);
    },
    onEmitSuccess(data = {}) {
      this.$emit("success", data);
    },
    inintForm() {
      this.$nextTick(() => {
        this.$refs["caseForm"].resetFields();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  box-sizing: border-box;
  height: 100%;
  padding-bottom: 60px;
  position: relative;
  overflow: hidden;
  background: #fff;
  .page-container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.control-btn-group {
  box-sizing: border-box;
  width: 100%;
  background-color: #fff;
  padding: 12px 24px;
  position: absolute;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  z-index: 2006;
  text-align: right;
}
.medias-list-wrap {
  display: inline-block;
  max-width: 100%;
  ::v-deep {
    .transition-el {
      max-height: none;
    }
  }
  .medias-item {
    display: block;
    width: 100px;
    height: 100px;
    margin: 5px;
  }
  .video-medias-item {
    box-sizing: border-box;
    padding: 5px 0;
    margin: 5px;
    width: 280px;
    height: 100px;
    position: relative;
    padding-right: 20px;
    background-color: #ddd;
    border: 1px solid #ddd;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .remove-video-icon {
      position: absolute;
      bottom: 5px;
      right: 2px;
      font-size: 16px;
      cursor: pointer;
      color: #c51515;
    }
    ::v-deep {
      .basic-upload-wrap {
        width: 150px;
        height: 90px;
      }
      .img-upload-wrap {
        width: 90px;
        height: 90px;
      }
    }
  }
}
.cover-image {
  width: 150px;
  height: 90px;
  ::v-deep {
    .img-upload-wrapper {
      height: auto;
    }
    .uploaded-img-preview {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.company-ruleForm {
  box-sizing: border-box;
  padding: 24px;
  .max-width-600 {
    max-width: 600px;
  }
  .base-form-item {
    max-width: 600px;
    overflow: hidden;
    ::v-deep {
      .el-form-item__content {
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .editor-loading {
    width: 100%;
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    color: #989898;
  }
}
</style>
